import { VirtualTableHeadCell } from '../../components/virtualized-table/types';
import { FlashTabStrings } from '../../store/bulk-device-flash/types';

export type TabContent = {
  title: FlashTabStrings;
  storageString: string;
  headerColumns: VirtualTableHeadCell[];
  sortableAccessors: { [key: string]: boolean };
  setColumnVisibility: Function;
  columnVisibility: string[];
  setColumnOrder: Function;
  columnOrder: string[];
  tableContainer: React.RefObject<HTMLElement>;
  onRowSelection?: Function;
  data: any[] | undefined;
};

export type ActionTypes = {
  value: string;
  title: string;
  disabled: boolean;
};

export enum ConfigType {
  ShortMessage = 'short message',
  ShortCommand = 'short command',
  SMHAdjust = 'SMH adjust',
  ConfigFiles = 'config files',
  SetDeviceParameters = 'set device parameters',
  Subscription = 'subscription',
  DeviceWakeups = 'device wakeups',
  ScheduleCommand= 'schedule command'
}

export enum SIMCredentialing {
  SimCredential = 'Sim Credentialing',
  EngineeringTemplate = 'Engineering Template',
}

export enum BootstrapType {
  ATT = 'AT&T',
  Vodafone = 'Vodafone'
}

export enum DeviceParameterConfigType {
  EOD = 'EOD',
  TamperResistance = 'tamper resistance',
}

export type Column = { title: any;accessor: string;type?: string };
export type selectedConfig = { id: string; columnheader:any; columns: Column[] };

const assetMake = [
  { title: 'Column A' },
  { title: 'Name', accessor: 'Asset Make' },
  { title: 'Data Type', accessor: 'String' },
  { title: 'Mandatory', accessor: 'Yes' },
  { title: 'Case Sensitive', accessor: 'Yes' },
  { title: 'Format', accessor: 'CAT' },
];

const assetSerailNumber = [
  { title: 'Column B' },
  { title: 'Name', accessor: 'Asset Serial Number' },
  { title: 'Data Type', accessor: 'String' },
  { title: 'Mandatory', accessor: 'Yes' },
  { title: 'Case Sensitive', accessor: 'Yes' },
  { title: 'Format', accessor: 'QVE74208' },
];

const deviceChar = [
  { title: 'Column C' },
  { title: 'Name', accessor: 'Device-Characterization' },
  { title: 'Data Type', accessor: 'String' },
  { title: 'Mandatory', accessor: 'Yes' },
  { title: 'Case Sensitive', accessor: 'Yes' },
  { title: 'Format', accessor: 'master' },
]
const fileType = [
  { title: 'Column D' },
  { title: 'Name', accessor: 'FileTypeId' },
  { title: 'Data Type', accessor: 'Number' },
  { title: 'Mandatory', accessor: 'Yes' },
  { title: 'Case Sensitive', accessor: 'Yes' },
  { title: 'Format', accessor: '10393' },
]

export const selectedConfigInfo = [
  {
    id: 'short message',
    columnheader: {
      columns: [
        [...assetMake],
        [...assetSerailNumber],
        [ ...deviceChar],
        [...fileType],
      ]
    }
  },

  {
    id: 'short command',
    columnheader: {
      columns: [
        [...assetMake],
        [  ...assetSerailNumber],
        [...deviceChar],
        [ ...fileType],
        [
          { title: 'Column E' },
          { title: 'Name', accessor: 'Data' },
          { title: 'Data Type', accessor: 'String' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: '000a751192234999caf792d89dc' },
        ]
      ]
    }
  },

  {
    id: 'config files',
    columnheader: {
      columns: [
        [...assetMake],
        [...assetSerailNumber],
        [...deviceChar],
        [...fileType],
        [
          { title: 'Column E' },
          { title: 'Name', accessor: 'hash' },
          { title: 'Data Type', accessor: 'Number' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: '25979135fc62efe89f79f87b9454bbad15602ae7' },
        ],
        [
          { title: 'Column F' },
          { title: 'Name', accessor: 'Hex Payload' },
          { title: 'Data Type', accessor: 'Number' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: 'PEZpbGVUeXBlIE51bWJlcj0iMTAwMTAiIFR4TWV0cmljPSI0MCIgUnhNZXRyaWM9IjUiIC8' },
        ],
      ]
    }
  },
  {
    id: 'device wakeups',
    columnheader: {
      columns: [
        [
          { title: 'Column A' },
          { title: 'Name', accessor: 'Device Id' },
          { title: 'Data Type', accessor: 'string' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: '000A75069B571283d2b9ec3' },
        ],
        [
          { title: 'Column B' },
          { title: 'Name', accessor: 'Device Type' },
          { title: 'Data Type', accessor: 'string' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: 'A5:N2' },
        ],
      ]
    }
  },

  {
    id: 'EOD',
    columnheader: {
      columns: [
        [...assetMake ],
        [...assetSerailNumber],
        [ ...deviceChar],
        [
          { title: 'Column D' },
          { title: 'Name', accessor: 'Eod' },
          { title: 'Data Type', accessor: 'Time' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Case Sensitive', accessor: 'Yes' },
          { title: 'Format', accessor: '12:00' },
        ],
      ]
    }
  },
  {
    id: 'tamper resistance',
    columnheader: {
      columns: [
        [ ...assetMake],
        [...assetSerailNumber],
        [ ...deviceChar ],
        [
          { title: 'Column D' },
          { title: 'Name', accessor: 'Disable Derate Start Mode' },
          { title: 'Data Type', accessor: 'String' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Case Sensitive', accessor: 'Yes' },
          { title: 'Format', accessor: 'normal | derate | disable' },
        ],
        [
          { title: 'Column E' },
          { title: 'Name', accessor: 'Disable Derate Tamper Resistance' },
          { title: 'Data Type', accessor: 'String' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Case Sensitive', accessor: 'Yes' },
          { title: 'Format', accessor: 'off | level_1 | level_2 | level_3' },
        ],
      ]
    }
  },
  {
    id: 'schedule command',
    columnheader: {
      columns: [
        [
          { title: 'Column A' },
          { title: 'Name', accessor: 'Device Id' },
          { title: 'Data Type', accessor: 'string' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: '000A75069B571283d2b9ec3' },
        ],
        [
          { title: 'Column B' },
          { title: 'Name', accessor: 'Device Type' },
          { title: 'Data Type', accessor: 'string' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: 'A5:N2' },
        ],
        [
          { title: 'Column C' },
          { title: 'Name', accessor: 'Data' },
          { title: 'Data Type', accessor: 'String' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: '000a751192234999caf792d89dc' },
        ],
        [
          { title: 'Column D' },
          { title: 'Name', accessor: 'FileType' },
          { title: 'Data Type', accessor: 'Number' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Case Sensitive', accessor: 'Yes' },
          { title: 'Format', accessor: '10393' },
        ],
        [
          { title: 'Column E' },
          { title: 'Name', accessor: 'Frequency' },
          { title: 'Data Type', accessor: 'Number' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: '5' },
        ],
        [
          { title: 'Column F' },
          { title: 'Name', accessor: 'Action' },
          { title: 'Data Type', accessor: 'String' },
          { title: 'Mandatory', accessor: 'Yes' },
          { title: 'Format', accessor: 'Add | Update | Delete' },
        ],
      ]
    }
  },
];

